export var UTM_SOURCE = 'utm_source';
export var UTM_MEDIUM = 'utm_medium';
export var UTM_CAMPAIGN = 'utm_campaign';
export var UTM_TERM = 'utm_term';
export var UTM_CONTENT = 'utm_content';
export var UTMZ_SOURCE = 'utmcsr';
export var UTMZ_MEDIUM = 'utmcmd';
export var UTMZ_CAMPAIGN = 'utmccn';
export var UTMZ_TERM = 'utmctr';
export var UTMZ_CONTENT = 'utmcct';
export var GCLID = 'gclid';
export var FBCLID = 'fbclid';
export var EMPTY_VALUE = 'EMPTY';
export var BASE_CAMPAIGN = {
    utm_source: undefined,
    utm_medium: undefined,
    utm_campaign: undefined,
    utm_term: undefined,
    utm_content: undefined,
    referrer: undefined,
    referring_domain: undefined,
    gclid: undefined,
    fbclid: undefined,
};
export var MKTG = 'MKTG';
//# sourceMappingURL=constants.js.map